
import React from 'react'
import classNames from 'classnames'
import Helpers from '../../../../_plugins/lib/helpers'
import SharedConfig from '../../../config/sharedConfig.js'
import ReduxStores from '../../../stores/connects'
import translations from '../../../config/components/alerts/uk'
import { object } from 'prop-types'

class DiscountAlert extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      visible: true,
      logo: ''
    }
    this.closeAlert = this.closeAlert.bind(this)
  }

  componentDidUpdate () {
    if (!this.state.logo) {
      Helpers.getAgentLogo(this.props.agentData.agent, this.props.settings.soapiBase)
      .then(logo => {
        if (logo) {
          this.setState({
            logo
          })
        }
      }).catch(error => {
        // Catch this error, as sometimes no data comes back
      })
    }
    this.props.onShowHide(!(!this.state.visible || (!this.getMessage() && !this.state.logo)))
  }

  getMessage () {
    const { pageName, agentData, translationConfig: { discountApplied, cashbackApplied, emailDiscountApplied } } = this.props

    if (pageName && pageName.indexOf('email') > -1) {
      return pageName === 'customer-login' ? 'Please login to apply your email discount' : emailDiscountApplied
    }

    if (!agentData) return false

    if (parseInt(agentData.promocode, 10)) {
      return pageName === 'customer-login' ? 'Please login to apply your discount' : discountApplied
    }

    if (parseInt(agentData.cashback, 10)) {
      return pageName === 'customer-login' ? 'Please login to apply your cashback code' : cashbackApplied
    }

    if (agentData.name === SharedConfig.midocoAgent) {
      return 'Die übermittelten Angaben sind leider nicht vollständig. Bitte starten Sie Ihre Anfrage durch manuelle Eingabe in der Suchmaske'
    }

    if (agentData.agentsByUrl && agentData.agentsByUrl.midocoid) {
      return 'Die übermittelten Angaben sind leider nicht vollständig. Bitte starten Sie Ihre Anfrage durch manuelle Eingabe in der Suchmaske'
    }

    if (agentData.agent === SharedConfig.wowcherCode) {
      return 'Remember to enter your Wowcher/Living Social code'
    }

    return false
  }

  closeAlert () {
    this.setState({
      visible: false
    })
  }

  render () {
    const { agentData, translationConfig: { inPartnership } } = this.props
    const { visible, logo } = this.state
    const message = this.getMessage()
    const discountAlertClass = classNames({
      'alert': true,
      'text-center': true,
      'alert-warning': !logo,
      'alert-dismissible': !logo,
      'alert-neutral': logo,
      'affiliateBannerWrapper': logo
    })

    if (!visible || (!message && !logo)) return null
    return (
      <div id='discountAlert' className={discountAlertClass}>
        {logo && (
          <div className='affiliateBanner'>
            <div>
              <img src={logo} alt={agentData.name} />
            </div>
            <div>
              <small className='show'>
                { inPartnership }
                { message && message !== ' ' && (
                  <span>{', '}</span>
                )}
                { message && message !== ' ' && (
                  <div>{ message }</div>
                )}
              </small>
            </div>
          </div>
        )}
        {message && !logo && (
          <div>
            <button type='button' className='close' onClick={this.closeAlert} aria-label='Close'><span aria-hidden='true'>x</span></button>
            <div>{ message }</div>
          </div>
        )}
      </div>
    )
  }
}

DiscountAlert.propTypes = {
  settings: object,
  translationConfig: object
}

DiscountAlert.defaultProps = {
  translationConfig: translations
}

export default ReduxStores(DiscountAlert, ['agents'], true)
